/**
 * Clause Routes
 */
import React from 'react';
import { createRoute } from '@tanstack/react-router';
import { createPermissionBeforeLoad } from '@bb/session-manager';
import { authLayoutRoute } from '../rootRoute';
import * as groups from '../../groups.config';

const ClauseLibrary = React.lazy(() => import('../../pages/ClauseLibrary/ClauseLibrary'));

const clausePermission = createPermissionBeforeLoad({
  permissions: [groups.CLAUSE_EDITOR_PERMISSION],
  forbiddenPath: '/bbweb/home',
});

/**
 * Clause Library page
 */
export const clauseLibraryRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/clauses',
  beforeLoad: clausePermission,
  component: ClauseLibrary,
});

export const clauseRoutes = [clauseLibraryRoute];
